import { ComponentType, FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, useLocation } from 'react-router-dom';

import { Loading } from 'common/components';
import { AppRoutes } from 'modules/router';
import ErrorPage from 'pages/ErrorPage';
import { TellUsAboutYourselfLocationState } from 'pages/TellUsAboutYourself';
import { useGetAccountQuery } from 'user/api';

export const withUserAccount =
  <P extends object>(WrappedComponent: ComponentType<P>): FC<P> =>
  (props): ReactElement => {
    const { t: tLoading } = useTranslation('common', { keyPrefix: 'loading' });

    const { isLoading, data, isError, error } = useGetAccountQuery();
    const location = useLocation();

    // add type guard
    if (!data && isError) return <ErrorPage status={(error as any).status} message={(error as any).data} />;
    if (isLoading) return <Loading label={tLoading('loadingYourAccount')} />;

    // Redirect unregistered users to tell-us-about-yourself page
    if (data && !data.isRegistrationCompleted && location.pathname !== AppRoutes.TellUsAboutYourself) {
      const state: TellUsAboutYourselfLocationState = {
        from: location.pathname + location.search,
      };
      return <Redirect to={{ pathname: AppRoutes.TellUsAboutYourself, state }} />;
    }

    return data ? <WrappedComponent {...props} /> : <></>;
  };
